// export const UID = 3807
// export const TEAM_LEADER_UID = 1249
export const UID = Number(process.env.VUE_APP_UID)
export const TEAM_LEADER_UID = Number(process.env.VUE_APP_TEAM_LEADER_UID)
